/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import { GlobalState } from '../../actions';

export const albumEditSelector = (state: GlobalState) => state.playlistAdmin.albumEdit;

export const albumEditAlbumSelector = (state: GlobalState) => albumEditSelector(state).album;

export const albumEditAlbumSongsSelector = (state: GlobalState) => albumEditSelector(state).albumSongs;

export const albumEditUploadedImageIdSelector = (state: GlobalState) => albumEditSelector(state).albumUploadedImageId;

export const albumEditAlbumNameSelector = (state: GlobalState) => {
    const album = albumEditAlbumSelector(state);
    if (album) {
        return album.name;
    } else {
        return undefined;
    }
};

export const albumEditMusicbrainzSelector = (state: GlobalState) => albumEditSelector(state).musicBrainz;
export const albumEditMusicbrainzLoadingSelector = (state: GlobalState) =>
    albumEditSelector(state).musicBrainzIsLoading;

export const albumByIdSelector = (albumId: string) => (state: GlobalState) =>
    albumEditSelector(state).albumMap[albumId];
export const albumMusicbrainzReleaseByIdSelector = (releaseId: string) => (state: GlobalState) =>
    albumEditSelector(state).musicBrainzReleaseMap[releaseId];
